import React, { useEffect, useMemo, useState } from "react";
import {
  CHAIN,
  TonConnectButton,
  TonConnectUIProvider,
  useTonConnectUI,
} from "@tonconnect/ui-react";

const Header = () => {
  return (
    <div className="snftHeader">
      <div className="snftLogo">SimpleNFT app</div>
      <TonConnectButton />
    </div>
  );
};

export default Header;
